const EventEmitter = require('event-emitter')
export default new EventEmitter()
